module.exports = __webpack_public_path__ + "img/bgQQ.e2571394.jpg";